import { useState } from "react";
import Button from "./Buttons/Button";
import Modal from "./Modal";
import DatePicker from "./Inputs/Date";
import styled from "styled-components";

interface InspectionSubmitModalProps {
  show: boolean;
  plannedDate: Date;
  onDismiss: () => void;
  onSubmit: (inspectionDate: Date) => void;
  fieldYear: number;
}

const InspectionSubmitModal = ({
  show,
  plannedDate,
  onDismiss,
  onSubmit,
  fieldYear,
}: InspectionSubmitModalProps) => {
  const today = new Date();
  const minDate = new Date(fieldYear, 0, 1);
  const [inspectionDate, setInspectionDate] = useState<Date>(plannedDate);

  return (
    <Modal show={show} onDismiss={onDismiss}>
      <Modal.Header>Schouw indienen</Modal.Header>
      <Modal.Body>
        <span>
          Let op: Na het indienen is het niet meer mogelijk om wijzigingen aan
          te brengen.
        </span>
        <span>Klopt de schouwdatum?</span>
        <DatePickerContainer>
          Datum schouw:
          <DatePicker
            onChange={(date) => date && setInspectionDate(new Date(date))}
            date={inspectionDate.toDateString()}
          />
        </DatePickerContainer>
        {inspectionDate > today && (
          <ErrorMessage>
            Schouwdatum kan niet in de toekomst liggen
          </ErrorMessage>
        )}
        {inspectionDate < minDate && (
          <ErrorMessage>
            Schouwdatum mag niet voor 1 januari van beheerjaar {fieldYear}{" "}
            liggen
          </ErrorMessage>
        )}
      </Modal.Body>
      <Modal.Footer>
        <ButtonContainer>
          <Button
            color="green"
            size="medium"
            label={"Indienen bij collectief"}
            disabled={inspectionDate > today || inspectionDate < minDate}
            onClick={() => onSubmit(inspectionDate)}
          />
          <Button
            bordered
            size="medium"
            color="white"
            label={"Annuleren"}
            onClick={onDismiss}
          />
        </ButtonContainer>
      </Modal.Footer>
    </Modal>
  );
};

export default InspectionSubmitModal;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`;

const DatePickerContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 12px 0;
  gap: 12px;
`;

const ErrorMessage = styled.div`
  color: #f92b2b;
  font-family: "Roboto";
  font-style: normal;
  font-size: 13px;
  line-height: 120%;

  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
`;
